import { _IdpData } from './idpData';

export namespace Oidc {
  export import IdpData = _IdpData;
}
